import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is the DearDr web platform same as the mobile app?",
    a: "Yes — your DearDr account, progress and subscription work seamlessly across the website and the mobile app. Log in once and continue from any device.",
  },
  {
    q: "How is the User ID generated?",
    a: "When you sign up, we auto-generate a unique DearDr User ID (format: DDR-XXXXXX). You can use either your email or this User ID along with your password to log in.",
  },
  {
    q: "What if I forget my password?",
    a: "Click 'Forgot Password' on the login page, enter your email, and we'll email you a secure reset link valid for 1 hour.",
  },
  {
    q: "Is there a free trial?",
    a: "Yes — you get 7 days of full access to DearDr Pro features. No credit card required.",
  },
  {
    q: "Which payment methods do you support?",
    a: "We support UPI, credit/debit cards, netbanking and wallets via Razorpay (rolling out shortly). Until then, you can express interest by selecting a plan and our team will reach out.",
  },
  {
    q: "Can I cancel my subscription anytime?",
    a: "Yes, you can cancel anytime from your dashboard. Your access will continue until the end of the current billing period.",
  },
  {
    q: "Do you offer offline content?",
    a: "Yes — the DearDr mobile app supports downloads of notes and videos for offline study (Pro members).",
  },
];

export default function Faqs() {
  return (
    <section id="faqs" className="py-20 md:py-28 bg-slate-50/60">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-700 bg-blue-50 px-3 py-1.5 rounded-full">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-600" /> FAQ
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mt-4">
            Questions, answered
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full bg-white rounded-2xl border border-slate-200 px-2">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-slate-900 font-semibold px-4 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-4 text-slate-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
